export const radii = {
  'futureTheme.radius-none': '0px',
  'futureTheme.radius-xxs': '2px',
  'futureTheme.radius-xs': '4px',
  'futureTheme.radius-sm': '6px',
  'futureTheme.radius-md': '8px',
  'futureTheme.radius-lg': '10px',
  'futureTheme.radius-xl': '12px',
  'futureTheme.radius-2xl': '16px',
  'futureTheme.radius-3xl': '20px',
  'futureTheme.radius-4xl': '24px',
  'futureTheme.radius-5xl': '32px',
  'futureTheme.radius-full': '9999px',
} as const
